import * as React from "react";
import classNames from "classnames";
import { Box } from "@dropbox/dig-foundations";
import { SimpleTruncate } from "../simple-truncate";
import { Text } from "@dropbox/dig-components/typography";
import css from "./SubText.module.css";

export interface SubTextProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, "color"> {
  /**
   * The subtext of the child.
   * If this is a non-string react node this component will not attempt to truncate it.
   * It is the responsibility of the implementer to ensure the content gets appropriately truncated.
   */
  children?: React.ReactNode;
}

export const _SubText: React.FC<React.PropsWithChildren<SubTextProps>> = ({
  children,
  className,
  ...rest
}) => {
  const childrenIsString = typeof children === "string";
  const maybeTruncate = childrenIsString ? (
    <SimpleTruncate>{children}</SimpleTruncate>
  ) : (
    children
  );
  return (
    <Box
      as={Text}
      color="Text Subtle"
      size="small"
      variant="label"
      className={classNames(css.subTextRoot, className)}
      display="block"
      marginTop="2"
      {...rest}
    >
      {maybeTruncate}
    </Box>
  );
};
